// ========== Custom debounce wait time used within web register. ========== //
export type DebounceOptions = {
  wait: number
  maxWait: number
}

export const DEBOUNCE_OPTIONS: DebounceOptions = {
  wait: 500,
  maxWait: 800,
}
